import Table from "./TableLite";

export default Table;
